import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { Recurrence } from 'ish-core/models/recurrence/recurrence.model';
import { DatePipe } from 'ish-core/pipes/date.pipe';
import { FrequencyPipe } from 'ish-core/pipes/frequency.pipe';

@Component({
  selector: 'ish-order-recurrence',
  templateUrl: './order-recurrence.component.html',
  styleUrls: ['./order-recurrence.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, FrequencyPipe, DatePipe],
})
export class OrderRecurrenceComponent {
  readonly recurrence = input.required<Recurrence>();

  @Input() labelCssClass: string;
  @Input() valueCssClass: string;
}
